import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { editCarHouseUser } from '../store/actions/carHouseUser-actions';
import { editCarHouseAdmin } from '../store/actions/carHouseAdmin-actions';
import { getSelf } from '../store/actions/auth-actions';
import { Form, Row, Col, Input, Button, message, Modal } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import Spinner from '../components/UI/Spinner/Spinner';
import { resetPassword } from '../store/actions/user-actions';
import { useTranslation } from 'react-i18next'; // 👈 Dodato

const UserProfile = () => {
  const { t } = useTranslation(); // 👈 Hook za prevod
  const { loggedInUser, isLoading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const [openChangePassForm, setOpenChangePassForm] = useState(false);
  const [form] = Form.useForm();
  const [changePassForm] = Form.useForm();

  const onFinish = async (values) => {
    let body = {};

    Object.keys(loggedInUser).forEach((key) => {
      if (key in values && loggedInUser[key] !== values[key]) {
        body[key] = values[key] || null;
      }
    });

    if (Object.keys(body).length === 0) return;

    try {
      await editUser(body);
      message.success(t('common.save') + 'd'); // ili koristi drugi prevod ako postoji
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(getSelf(loggedInUser.id));
    }
  };

  const editUser = async (body) => {
    if (loggedInUser.role.name === 'user') {
      dispatch(editCarHouseUser({
        carHouseId: loggedInUser.carHouseId,
        userId: loggedInUser.id,
        body,
      }));
    } else {
      dispatch(editCarHouseAdmin({
        carHouseId: loggedInUser.carHouseId,
        carHouseAdminId: loggedInUser.id,
        body,
      }));
    }
  };

  const onFinishFailed = () => {
    message.error(t('common.unexpectedError'));
  };

  const onSubmit = (values) => {
    const body = {
      passwordOld: values.passwordOld,
      password: values.password,
      passwordRepeat: values.passwordRepeat,
    };

    dispatch(resetPassword({ userId: loggedInUser.id, body }));
  };

  let content = isLoading ? (
    <Spinner />
  ) : (
    <>
      <Form
        form={form}
        layout="vertical"
        initialValues={loggedInUser}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={16} className="profileEditContainer">
          <Col xs={24}>
            <Form.Item name="firstName" label={t('modalForm.firstName')}>
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24}>
            <Form.Item name="lastName" label={t('modalForm.lastName')}>
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24}>
            <Form.Item name="email" label={t('modalForm.email')}>
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24}>
            <Form.Item name="phone" label={t('modalForm.phone')}>
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24}>
            <Form.Item name="address" label={t('modalForm.address')}>
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24}>
            <Button
              type="primary"
              htmlType="submit"
              icon={<SaveOutlined />}
            >
              {t('common.save')}
            </Button>
          </Col>
          <Col xs={24} style={{ marginTop: '20px' }}>
            <Button onClick={() => setOpenChangePassForm(true)}>
              {t('common.changePassword') || 'Change Password'}
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );

  return (
    <>
      <h2>{t('common.profile')}</h2>
      {content}
      <Modal
        open={openChangePassForm}
        forceRender
        title={t('common.changePassword') || 'Change Password'}
        okText={t('common.confirm')}
        cancelText={t('common.cancel')}
        onCancel={() => setOpenChangePassForm(false)}
        onOk={() => {
          changePassForm.validateFields()
            .then((values) => {
              changePassForm.resetFields();
              onSubmit(values);
            })
            .catch(() => {
              message.error(t('common.unexpectedError'));
            });
        }}
      >
        <Form form={changePassForm} layout="vertical">
          <Row gutter={16}>
            <Col xs={24}>
              <Form.Item name="passwordOld" label={t('common.passwordOld')}>
                <Input.Password />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item name="password" label={t('common.passwordNew')}>
                <Input.Password />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item name="passwordRepeat" label={t('common.passwordRepeat')}>
                <Input.Password />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default UserProfile;
